import { render } from "./GetDebtButton.vue?vue&type=template&id=af4ee136&scoped=true"
import script from "./GetDebtButton.vue?vue&type=script&lang=js"
export * from "./GetDebtButton.vue?vue&type=script&lang=js"

import "./GetDebtButton.vue?vue&type=style&index=0&id=af4ee136&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af4ee136"

export default script